import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import {
  OnPersonChangesSocketEvent,
  PersonChangesSocketMessage,
} from '../types';

export function useSocketPersonChanges(onEvent: OnPersonChangesSocketEvent) {
  const channel = useGetSocketChannel(SocketMessageType.PERSON_CHANGES);

  useSocketEvent(channel, (data: PersonChangesSocketMessage) => {
    if (data.type === SocketMessageType.PERSON_CHANGES) onEvent(data);
  });
}
